import type { ServiceDataLoadingState } from './types.tsx';

export const emptyServiceDataState: ServiceDataLoadingState = Object.freeze({
	data: null,
	error: null,
	loading: false,
	loadedAt: 0,
});
